import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './Button';
const list = ['Tomo 1 — Orígenes y Culturas', 'Tomo 2 — Conquista y Colonia', 'Tomo 3 — Independencia', 'Tomo 4 — Siglo XIX', 'Tomo 5 — Siglo XX', 'Tomo 6 — Procesos Contemporáneos', 'Tomo 7 — Fuentes Históricas', 'Tomo 8 — Actividades y Evaluaciones', 'Bono 1 — Banco de Evaluaciones y Rúbricas', 'Bono 2 — Glosario Completo de Términos', 'Bono 3 — Manual de Respuestas para Preguntas Difíciles', 'Bono 4 — Líneas del Tiempo Completas', 'Garantía de 7 días sin preguntas', 'Acceso inmediato'];
export function FinalCTA() {
  return <section className="relative overflow-hidden bg-black px-4 py-20" data-id="element-74">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(184,134,11,.14),transparent_60%)]" data-id="element-75" />
      <div className="relative mx-auto max-w-4xl text-center" data-id="element-76">
        <h2 className="font-serif text-3xl font-bold leading-tight sm:text-5xl" data-id="element-77">
          El próximo lunes puedes seguir improvisando...
          <br data-id="element-78" />
          <span className="text-gold-gradient" data-id="element-79">
            O resolver tu año entero de Historia en solo 5 MINUTOS desde hoy.
          </span>
        </h2>

        <p className="mx-auto my-9 max-w-2xl text-lg leading-relaxed text-gray-300" data-id="element-80">
          Vos ya eres un buen docente. El Mega Pack te da el tiempo y las
          herramientas para que eso se note en cada clase.
        </p>

        <div className="rounded-3xl border-2 border-gold/30 bg-black p-7 shadow-[0_0_40px_rgba(212,175,55,.1)] sm:p-10" data-id="element-81">
          <h3 className="border-b border-dark-border pb-5 text-xl font-bold" data-id="element-82">
            Todo lo que incluye:
          </h3>

          <div className="my-8 grid gap-3 text-left md:grid-cols-2" data-id="element-83">
            {list.map(item => <p className="flex gap-2 text-sm text-gray-200" key={item} data-id="element-84">
                <Check size={17} className="shrink-0 text-gold" data-id="element-85" />
                {item}
              </p>)}
          </div>

          <p className="mb-3 font-serif text-xl font-bold" data-id="element-86">
            Mega Pack Historia 360
          </p>
          <p className="mb-6 text-sm text-gray-400" data-id="element-87">
            Resuelve tu año entero de Historia en solo 5 MINUTOS.
          </p>

          <Button href="#pricing" className="w-full sm:w-auto" data-id="element-88">
            QUIERO MI MEGA PACK AHORA
          </Button>

          <p className="mt-5 text-xs text-gray-500" data-id="element-89">
            Garantía de 7 días · Pago seguro · Acceso inmediato · Pagas en tu
            moneda local
          </p>
        </div>
      </div>
    </section>;
}